module.exports = __webpack_public_path__ + "assets/Linkedin.6bf4e3fe.svg";